export const formatString = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const nomeSobrenome = (string) => {
  const nomeSeparado = string.split(' ');
  return `${formatString(nomeSeparado[0])} ${formatString(
    nomeSeparado[nomeSeparado.length - 1]
  )}`;
};

export const multipleFormatString = (text) => {
  if (!text || typeof text !== 'string') return text;
  return text
    .split(' ')
    .map((word) => formatString(word))
    .join(' ');
};
